import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Card from '../common/Card';
import Loading from '../common/Loading';

const OwnerLogs = () => {
  const [logs, setLogs] = useState({ myLogs: [], simplesLogs: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('my');

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await api.get('/logs/owner');
      console.log('Owner logs reçus:', response.data); // Debug
      setLogs(response.data.data || { myLogs: [], simplesLogs: [] });
    } catch (error) {
      console.error('Erreur lors de la récupération des logs:', error);
      setError('Erreur lors du chargement des logs');
      setLogs({ myLogs: [], simplesLogs: [] });
    } finally {
      setLoading(false);
    }
  };

  const getActionBadgeColor = (action) => {
    const colors = {
      CREATE: 'bg-green-100 text-green-800',
      UPDATE: 'bg-blue-100 text-blue-800',
      DELETE: 'bg-red-100 text-red-800',
      ACTIVATE: 'bg-green-100 text-green-800',
      DEACTIVATE: 'bg-orange-100 text-orange-800',
      LOGIN: 'bg-purple-100 text-purple-800',
      PASSWORD_CHANGE: 'bg-yellow-100 text-yellow-800',
    };
    return colors[action] || 'bg-gray-100 text-gray-800';
  };

  if (loading) return <Loading />;

  const currentLogs = activeTab === 'my' ? logs.myLogs : logs.simplesLogs;

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-8">
        Journal d'activités
      </h1>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}

      {/* Tabs */}
      <div className="flex space-x-4 mb-6">
        <button
          onClick={() => setActiveTab('my')}
          className={`px-6 py-2 rounded-lg font-semibold transition ${
            activeTab === 'my'
              ? 'bg-gradient-blue text-white'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }`}
        >
          Mon activité ({logs.myLogs?.length || 0})
        </button>
        <button
          onClick={() => setActiveTab('simples')}
          className={`px-6 py-2 rounded-lg font-semibold transition ${
            activeTab === 'simples'
              ? 'bg-gradient-blue text-white'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }`}
        >
          Activité de mes simples ({logs.simplesLogs?.length || 0})
        </button>
      </div>

      {/* Liste des logs */}
      <Card>
        <div className="space-y-3">
          {currentLogs && currentLogs.length > 0 ? (
            currentLogs.map((log) => (
              <div
                key={log._id}
                className="flex items-start justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition"
              >
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <span
                      className={`px-2 py-1 text-xs font-semibold rounded ${getActionBadgeColor(
                        log.action
                      )}`}
                    >
                      {log.action}
                    </span>
                  </div>
                  <p className="font-semibold text-gray-800">{log.actorName}</p>
                  <p className="text-sm text-gray-600">{log.details}</p>
                  {log.targetName && (
                    <p className="text-xs text-gray-500 mt-1">
                      Cible: {log.targetName}
                    </p>
                  )}
                </div>
                <div className="text-right ml-4">
                  <p className="text-sm text-gray-500">
                    {new Date(log.createdAt).toLocaleDateString('fr-FR')}
                  </p>
                  <p className="text-xs text-gray-400">
                    {new Date(log.createdAt).toLocaleTimeString('fr-FR')}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 py-8">
              Aucun log trouvé. Les logs apparaîtront ici après des actions.
            </p>
          )}
        </div>
      </Card>
    </div>
  );
};

export default OwnerLogs;